import React, { useEffect, useState } from 'react';
import { COOKIE, getCookie } from '../../../services/cookie';
import constants from '../../../constants/constants';
import { fetchAdminApi } from '../../../services/api';
import { Card, Row, Col, Button, Divider, Tag, Form, Spin, message, Input, Radio, Select, Space, Checkbox, Popconfirm } from 'antd';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useWatch } from 'antd/es/form/Form';
import { DOB } from '../../../globalFunctions/GlobalFunctions';
import moment from 'moment';
import LocadtrAssessment from './LocadtrAssessment';

const { Option } = Select;

const ScreeningForm = () => {
	const [form] = Form.useForm();
	const history = useHistory()
	const adminClientValuefromSession = JSON.parse(sessionStorage.getItem("adminClientValue"));
	const adminEnquiryValuefromSession = JSON.parse(sessionStorage.getItem("enquiryDetails"));
	const loginType = getCookie(COOKIE.LoginType);
	const [loader, setLoader] = useState(false);
	const [screeningData, setScreeningData] = useState(null);
	const [formValues, setFormValues] = useState({});
	const [noteId, setNoteId] = useState(null);
	const assess6Value = useWatch('assess_6', form);
	const [listAssociates, setListAssociates] = useState([]);
	const [isSigned, setIsSigned] = useState(false);
	const [noteData, setNoteData] = useState(false);
	const [status, setStatus] = useState(null);
	const [showEsign, setShowEsign] = useState(null);
	const [enableEdit, setEnableEdit] = useState(false);
	const [updatedByName, setUpdatedByName] = useState("");
	const [assessmentQuestions, setAssessmentQuestions] = useState(null);

	let admin_id = getCookie(COOKIE.ClientId);
	const isAdmin = getCookie(COOKIE.LoginType) === "0" ? false : true;

	// Pronoun states
	const [pronoun, setPronoun] = useState("She/He");
	const [possPronoun, setPossPronoun] = useState("His/Her");
	const [beVerb, setBeVerb] = useState("is");
	const [past, setPast] = useState("s");
	const [pastVar, setPastVar] = useState("es");

	// Date of notes
	const current = new Date();
	const [noteDate, setNoteDate] = useState({
		date: current.getDate(),
		month: (current.getMonth() + 1).toString().padStart(2, '0'),
		year: current.getFullYear()
	});
	const handleNoteDayChange = (value) => {
		setNoteDate({
			...noteDate,
			date: value
		});
	};
	const handleNoteMonthChange = (value) => {
		setNoteDate({
			...noteDate,
			month: value
		});
	};
	const handleNoteYearChange = (value) => {
		setNoteDate({
			...noteDate,
			year: value
		});
	};

	const resetNoteStates = () => {
		setScreeningData(null);
		setNoteData(null);
		setFormValues(null);
		setNoteId(null);
		setIsSigned(false);
		setStatus(null);
		setShowEsign(null);
	};

	const getScreeningAnswer = () => {
		setLoader(true);
		let client_id = null;
		if (isAdmin) {
			if (adminClientValuefromSession?.clientId) {
				client_id = adminClientValuefromSession?.clientId
			} else {
				client_id = adminEnquiryValuefromSession?.client_id;
			}
		} else {
			client_id = getCookie(COOKIE.ClientId)
		}
		fetchAdminApi(`/get-screening-answer/${client_id}`, 'get').then((res) => {
			setLoader(false);
			if (res?.code === 200) {
				setNoteData(res?.data);
				setScreeningData(res?.data?.self_assesment_data?.answers);
				let ScreeningData = {}
				const sd = res?.data?.screening_data?.screening;
				if (sd) {
					ScreeningData = sd;
					if (sd?.assessment_questions) {
						setAssessmentQuestions(sd.assessment_questions || null);
						sessionStorage.setItem("assessmentQuestions", JSON.stringify(sd.assessment_questions || null));
					}
				} else {
					const diagnosisMappedValues = mapDiagnosisValues(res?.data?.self_assesment_data?.answers?.new_assesment_disorder);
					ScreeningData = diagnosisMappedValues
				}
				setFormValues(ScreeningData || {});
				setNoteId(res?.data?.screening_data?.notes_id);
				if (res?.data?.screening_data?.signed_by) {
					setIsSigned(true); // disable the form if signed
				}
				setStatus(res?.data?.show_status || null);
				setShowEsign(res?.data?.show_esign);
				if (res?.data?.screening_data?.date_of_notes) {
					const noteDateObj = new Date(res.data.screening_data.date_of_notes);
					setNoteDate({
						date: noteDateObj.getDate().toString().padStart(2, '0'),
						month: (noteDateObj.getMonth() + 1).toString().padStart(2, '0'),
						year: noteDateObj.getFullYear().toString()
					});
				}
				// Access gender from the first object in the data array
				const gender = res?.data?.self_assesment_data?.answers?.gender?.toLowerCase();
				handlePronounChange(gender);
			} else {
				message.error(res?.message)
				resetNoteStates();
			}
		}).catch((error) => {
			setLoader(false);
			console.error('Error fetching screening data:', error);
			resetNoteStates();
		});
	};

	useEffect(() => {
		getScreeningAnswer();
	}, []);

	useEffect(() => {
		if (formValues && Object.keys(formValues).length > 0) {
			form.setFieldsValue(formValues);
		}
	}, [formValues, form]);

	const handlePronounChange = (value) => {
		if (value) {
			const gender = value?.toLowerCase();
			if (gender === "male") {
				setPronoun("He")
				setPossPronoun("His")
				setBeVerb("is")
				setPast("s")
				setPastVar("es")
			} else if (gender === "female") {
				setPronoun("She");
				setPossPronoun("Her")
				setBeVerb("is")
				setPast("s")
				setPastVar("es")
			} else {
				setPronoun("They");
				setPossPronoun("Their")
				setBeVerb("are")
				setPast("")
				setPastVar("")
			}
		} else {
			setPronoun("She/He")
			setPossPronoun("His/Her")
			setBeVerb("is")
			setPast("s")
			setPastVar("es")
		}
	}

	const lowPronoun = pronoun.toLowerCase();
	const lowPossPronoun = possPronoun.toLowerCase();

	const mapDiagnosisValues = (diagnosisObj = {}) => {
		const isLegacyEntry = (key, val) =>
			Array.isArray(val) && val.length === 3 && typeof val[0] === 'string' && typeof val[2] === 'string';

		const filtered = {};
		Object.entries(diagnosisObj).forEach(([key, values]) => {
			if (!isNaN(Number(key))) return;
			if (isLegacyEntry(key, values)) return;

			if (Array.isArray(values) && values.length > 0) {
				// Normalize all IDs to strings to match Select option values
				filtered[key] = values.map(v => String(v));
			}
		});
		return filtered;
	};

	let client_name;
	const getScreeningHeader = () => {
		let serial_no;
		if (adminClientValuefromSession?.clientId) {
			client_name = adminClientValuefromSession?.client_name ? adminClientValuefromSession?.client_name : "";
			serial_no = adminClientValuefromSession?.client_serial_number !== null ? adminClientValuefromSession?.client_serial_number : "";
		} else {
			client_name = adminEnquiryValuefromSession?.client_firstname ? adminEnquiryValuefromSession?.client_firstname + " " + adminEnquiryValuefromSession?.client_lastname : "";
			serial_no = adminEnquiryValuefromSession?.enquiry_id ? adminEnquiryValuefromSession?.enquiry_id : "";
		}
		return <div className='bg-amber-100 text-base font-semibold p-2 mb-3'><div className="container mx-auto">
			<Space size={'small'} wrap direction="vertical">
				<span>{loginType === "0" ? `My ${constants.ScreeningForm}` : `${constants.ScreeningForm} - ${client_name} (#${serial_no})`}</span>
				{isAdmin && <Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={handleBackClick}>{constants.BackBtn}</Button>}
			</Space>
		</div></div>;
	};

	const panelTitle = (title) => {
		return <div className='mt-5 px-2 mb-4 text-base italic underline font-bold'>{title}</div>
	};

	const calculateCageTestCount = (selectedAttempts) => {
		// If no selectedAttempts or empty object, return 0
		if (!selectedAttempts || Object.keys(selectedAttempts).length === 0) {
			return 0;
		}

		// If B (Not Applicable) is selected, return '-'
		if (selectedAttempts.B?.checked) {
			return '-';
		}

		// Count selected CAGE items (C, A, G, E)
		const cageKeys = ['C', 'A', 'G', 'E'];
		let count = 0;

		cageKeys.forEach(key => {
			if (selectedAttempts[key]?.checked) {
				count++;
			}
		});

		return count;
	};

	const getScreeningResultMessage = (count, type) => {
		if (typeof count !== 'number' || isNaN(count) || !constants.ScreeningResultMessages[type]) return '';

		const rules = constants.ScreeningResultMessages[type];

		for (const rule of rules) {
			if (count >= rule.min && count <= rule.max) {
				return rule.message;
			}
		}

		return '';
	};

	const cage_test_count = calculateCageTestCount(screeningData?.selectedattempts);
	const dast_test_count = parseInt(screeningData?.dast_test_count?.count, 10);
	const gambling_count = parseInt(screeningData?.gambling_count?.count, 10);
	const mmmh_test_count = parseInt(screeningData?.mmmh_test_count?.count, 10);

	const renderScreeningResults = () => {
		const screeningItems = [
			{
				label: 'CAGE-AID',
				value: cage_test_count,
				helpText: getScreeningResultMessage(cage_test_count, 'cage'),
				clientType: '1',
			},
			{
				label: 'DAST',
				value: isNaN(dast_test_count) ? '-' : dast_test_count,
				helpText: getScreeningResultMessage(dast_test_count, 'dast'),
				clientType: '1',
			},
			{
				label: 'GAMBLING',
				value: isNaN(gambling_count) ? '-' : gambling_count,
				helpText: getScreeningResultMessage(gambling_count, 'gambling'),
				clientType: '1',
			},
			{
				label: 'MODIFIED MINI',
				value: isNaN(mmmh_test_count) ? '-' : mmmh_test_count,
				helpText: getScreeningResultMessage(mmmh_test_count, 'mmmh'),
			},
			{
				label: 'FAMILY SCREENING',
				value: screeningData?.family_screening_count ?? '-',
				helpText: screeningData?.family_screening_result,
				clientType: '0',
			},
			{
				label: 'CODEPENDENCY SCREENING',
				value: screeningData?.codependency_screening_count ?? '-',
				helpText: screeningData?.codependency_screening_result,
				clientType: '0',
			},
		];

		const filteredItems = screeningItems.filter(
			item => !item.clientType || item.clientType === String(noteData?.client_type)
		);
		return (
			<Row gutter={[16, 16]}>
				{filteredItems.map((item) => (
					<Col xs={24} sm={12} md={6} key={item.label}>
						<Form.Item label={item.label} help={item.helpText}>
							<Input value={item.value} readOnly disabled />
						</Form.Item>
					</Col>
				))}
			</Row>
		);
	};

	const handleSubmit = async (type = null) => {
		try {
			const values = await form.validateFields();
			createNote(values, type);
		} catch (errorInfo) {
			// Scroll to first error field
			if (errorInfo?.errorFields?.length) {
				const firstErrorField = errorInfo.errorFields[0];
				form.scrollToField(firstErrorField.name, {
					behavior: 'smooth',
					block: 'center',
				});
			}
		}
	};

	// sentences for PDF
	const transformRecommendations = (selectedRecommendations = []) => {
		if (!selectedRecommendations.length) return {};

		if (selectedRecommendations.includes("no_intervention_referred_out")) {
			return { no_intervention_referred_out: true };
		}

		return selectedRecommendations.reduce((acc, key) => {
			acc[key] = true;
			return acc;
		}, {});
	};

	const mapDiagnosisValuesToLabels = (selectedValues = [], options = []) => {
		if (!Array.isArray(selectedValues)) return [];

		return selectedValues
			.map(val => {
				const option = options.find(opt => opt.value === val);
				return option ? option.label : null;
			})
			.filter(label => label !== null);
	};

	const handleDownloadPDF = async () => {
		try {
			const values = await form.validateFields();
			downloadPDF(values);
		} catch (errorInfo) {
			if (errorInfo?.errorFields?.length) {
				const firstErrorField = errorInfo.errorFields[0];
				form.scrollToField(firstErrorField.name, {
					behavior: 'smooth',
					block: 'center',
				});
			}
		}
	};

	const downloadPDF = async (values) => {
		const assessmentQuestionFromSession = JSON.parse(sessionStorage.getItem("assessmentQuestions"));
		const getFallbackHTML = (key) => extraProblemData?.[key]?.props?.dangerouslySetInnerHTML?.__html?.trim() || '';
		const assignedUser = listAssociates?.find(user => user.client_id == values.assignto);
		if (assignedUser) {
			values.assignto = `${assignedUser.firstname} ${assignedUser.lastname}`;
		}
		const screeningOption = getScreeningRadioOptions().find(
			option => option.value === values.screening_assessment
		);
		if (screeningOption) {
			values.screening_assessment = screeningOption.label;
		}

		values.client_name = client_name;
		values.client_type = noteData?.client_type;
		values.dt_created = `${noteDate.year}-${noteDate.month.padStart(2, '0')}-${noteDate?.date.toString().padStart(2, '0')}`;
		values.chemical_text = screeningData?.chemical_problem_para || getFallbackHTML("Chemical_Problem");
		values.gambling_text = screeningData?.gambling_problem_para || getFallbackHTML("Gambling_Problem");
		values.community_text = screeningData?.community_problem_para || getFallbackHTML("Community_Problem");
		values.mental_text = screeningData?.mental_problem_para || getFallbackHTML("Mental_Problem");
		values.medical_text = screeningData?.medical_problem_para || getFallbackHTML("Physical_Problem");
		values.social_text = screeningData?.social_problem_para || getFallbackHTML("Social_Problem");
		values.family_text = screeningData?.family_problem_para || getFallbackHTML("Family_Problem");
		values.spirituality_text = screeningData?.spirituality_problem_para || getFallbackHTML("Spiritual_Problem");
		values.education_text = screeningData?.education_problem_para || getFallbackHTML("Education_Problem");
		values.employment_text = screeningData?.employment_problem_para || getFallbackHTML("Employment_Problem");
		values.legal_text = screeningData?.legal_problem_para || getFallbackHTML("Legal_Problem");
		values.cage_test_count = cage_test_count;
		values.cage_test_result = getScreeningResultMessage(cage_test_count, 'cage');
		values.dast_test_count = isNaN(dast_test_count) ? '-' : dast_test_count
		values.dast_test_result = getScreeningResultMessage(dast_test_count, 'dast');
		values.gambling_count = isNaN(gambling_count) ? '-' : gambling_count;
		values.gambling_result = getScreeningResultMessage(gambling_count, 'gambling');
		values.mmmh_test_count = isNaN(mmmh_test_count) ? '-' : mmmh_test_count;
		values.mmmh_test_result = getScreeningResultMessage(mmmh_test_count, 'mmmh');
		values.family_screening_count = screeningData?.family_screening_count;
		values.family_screening_result = screeningData?.family_screening_result;
		values.codependency_screening_count = screeningData?.codependency_screening_count;
		values.codependency_screening_result = screeningData?.codependency_screening_result;
		values.esign_text = isSigned && noteData?.screening_data?.signed_by_name && noteData?.screening_data?.signed_on
			? `<br><br><i>E-signed by ${noteData.screening_data.signed_by_name} on ${moment(noteData.screening_data.signed_on).format(constants.dateformat)}</i>`
			: "";
		values.updated_text = isSigned && noteData?.screening_data?.screening?.updated_by && noteData?.screening_data?.screening?.updated_on
			? `<br><i>Updated by ${noteData?.screening_data?.screening?.updated_by} on ${moment(noteData?.screening_data?.screening?.updated_on).format(constants.dateformat)}</i>`
			: "";
		const selectedGaf = constants.GAFScaleOptions.find(option => option.value === values.gaf_scale);
		if (selectedGaf) {
			values.gaf_scale = `${selectedGaf.score}: ${selectedGaf.description}`
		}
		values.assessment_questions = assessmentQuestionFromSession;
		// Transform recommendations
		const recObj = transformRecommendations(values.recommendation || []);
		delete values.recommendation;
		values = {
			...values,
			...recObj,
		};

		diagnosisFields.forEach(field => {
			const selectedValues = values[field.name];

			if (selectedValues) {
				const labels = mapDiagnosisValuesToLabels(selectedValues, field.options);
				values[field.name] = labels;
			}
		});

		let documentValue = {
			answers: values,
			file_type: "screening-pdf",
		};
		if (adminClientValuefromSession?.clientId) {
			documentValue.client_id = adminClientValuefromSession?.clientId
		} else {
			if (adminEnquiryValuefromSession?.client_id) {
				documentValue.client_id = adminEnquiryValuefromSession?.client_id;
			} else {
				documentValue.enquiry_id = adminEnquiryValuefromSession?.enquiry_id;
			}
		}

		sessionStorage.setItem("documentValue", JSON.stringify(documentValue));
		window.open(constants.BaseUrl + `/view-document`);
	};

	const createNote = (value, type = null) => {
		const assessmentQuestionFromSession = JSON.parse(sessionStorage.getItem("assessmentQuestions"));
		setLoader(true);
		if (isSigned && enableEdit) {
			value.updated_by = updatedByName;
			value.updated_on = current.toISOString().split("T")[0];
		}
		if (assessmentQuestionFromSession?.length > 0) {
			value.assessment_questions = assessmentQuestionFromSession
		}
		let payload = {
			notes_content: null,
			notes_assesment: null,
			notes_plan: null,
			section_id: null,
			notes_type: "7",
			dt_created: `${noteDate.year}-${noteDate.month.padStart(2, '0')}-${noteDate?.date.toString().padStart(2, '0')}`,
			answers: value || {},
		};

		if (adminClientValuefromSession?.clientId) {
			payload.client_id = adminClientValuefromSession?.clientId
		} else {
			if (adminEnquiryValuefromSession?.client_id) {
				payload.client_id = adminEnquiryValuefromSession?.client_id;
			} else {
				payload.enquiry_id = adminEnquiryValuefromSession?.enquiry_id;
			}
		}
		payload.admin_id = admin_id;

		if (type === "esign") {
			payload.signed_by = admin_id;
			payload.dt_updated = current.toISOString().split("T")[0];
		}
		// If already signed and user is allowed to edit, retain signature info
		if (isSigned && enableEdit) {
			payload.signed_by = noteData?.screening_data?.signed_by;
			payload.signed_on = noteData?.screening_data?.signed_on;
		}

		let url, method;
		if (noteId) {
			url = "/edit-notes";
			method = "put";
			payload.notes_id = noteId;
		} else {
			url = "/add-notes";
			method = "post";
		}
		fetchAdminApi(url, method, payload)
			.then((res) => {
				if (res?.code && res.code === 200) {
					setNoteDate({
						...noteDate,
						date: current.getDate().toString(),
						month: (current.getMonth() + 1).toString(),
						year: current.getFullYear().toString()
					});
					message.success(res.message);
					handleRedirect();
				} else {
					message.error(res.message || 'Something went wrong');
				}
			})
			.catch((error) => {
				console.error('Error creating/updating note:', error);
				message.error('Failed to save note. Please try again.');
			})
			.finally(() => {
				setLoader(false);
			});
	};

	const getScreeningRadioOptions = () => {
		const clientType = String(noteData?.client_type);

		const dastScore = screeningData?.dast_test_count?.count ?? '-';
		const gamblingScore = screeningData?.gambling_count?.count ?? '-';
		const mmmmScore = screeningData?.mmmh_test_count?.count ?? '-';

		const familyScore = screeningData?.family_screening_count ?? '-';
		const codependencyScore = screeningData?.codependency_screening_count ?? '-';

		let screeningText = '';

		if (clientType === '1') {
			screeningText = `CAGE-AID: ${cage_test_count}, DAST: ${dastScore}, GAM: ${gamblingScore} and MMMH: ${mmmmScore}`;
		} else if (clientType === '0') {
			screeningText = `MMMH: ${mmmmScore}, Family Screening: ${familyScore} and Codependency Screening: ${codependencyScore}`;
		}

		const positiveText = `Recipient was informed that based on the scores on the ${screeningText} screening instruments, ${lowPronoun} meet${past} criteria for Coaching Counseling.`;

		const negativeText = `Recipient was informed that based on the scores on the ${screeningText} screening instruments, ${lowPronoun} do${pastVar} not meet criteria for Coaching Counseling.`;

		return [
			{
				label: positiveText,
				value: 'positive',
			},
			{
				label: negativeText,
				value: 'negative',
			},
		];
	};

	let educationlabelindex = constants.EducationOptions?.findIndex((val) => val?.value === screeningData?.family_10);
	let occupationlabelindex = constants.OccupationOptions?.findIndex((val) => val?.value === screeningData?.family_11);
	let maritalstatuslabelindex = constants.MaritalStatusOption?.findIndex((val) => val?.value === screeningData?.maritalstatus);
	const generateAddictionSentences = (formValues) => {
		const sentences = [];
		// Treatment history
		if (formValues?.drug_4) {
			const treatmentStatus = formValues?.drug_4 === 'been' ? 'has' : 'has never';
			sentences.push(`The client ${treatmentStatus} received treatment for addiction.`);

			// Add institute and therapist info if treatment was received
			if (formValues?.drug_4 === 'been') {
				if (formValues?.drug_5) {
					sentences.push(`Treatment was received at ${formValues?.drug_5}.`);
				}
				if (formValues?.drug_6) {
					sentences.push(`The treating therapist/doctor was ${formValues?.drug_6}.`);
				}
			}
		}

		// 12-step program experience
		if (formValues?.drug_8) {
			if (formValues?.drug_8 === 'no') {
				sentences.push("The client has no experience with 12-step programs.");
			} else if (formValues?.drug_8 === 'yes') {
				sentences.push("The client has experience with 12-step programs.");

				// Handle meetings/services (array from Select in 'tags' mode)
				if (Array.isArray(formValues?.drug_12) && formValues?.drug_12.length > 0) {
					const meetingList = formValues?.drug_12.join(', ');
					sentences.push(`The client has participated in the following meetings/services: ${meetingList}.`);
				}
			} else {
				// Catch unrecognized or new options (e.g., 'some')
				sentences.push(`The client has ${formValues?.drug_8} experience with 12-step programs.`);
			}
		}

		// Friends in recovery
		if (formValues?.drug_7) {
			const friends = formValues?.drug_7 === 'no' ? 'no' : 'some';
			sentences.push(`The client has ${friends} friends in recovery from substances or gambling.`);
		}

		// Longest abstinence period
		if (formValues?.drug_9) {
			sentences.push(`The client's longest period of abstinence from substances/gambling was ${formValues?.drug_9}.`);
		}

		return sentences;
	};
	// Function to generate mental health sentences for payload
	const generateMentalHealthSentences = (formValues) => {
		const sentences = [];

		// Mental health diagnoses
		if (formValues?.emotional_2 && formValues?.emotional_2.length > 0) {
			const emotionalDiagnoses = Array.isArray(formValues?.emotional_2) ? formValues?.emotional_2 : [];
			// If "None" is selected along with others, ignore it
			const hasNone = emotionalDiagnoses?.includes("None");

			const diagnoses = emotionalDiagnoses?.filter(
				(item) => item !== "Other" && item !== "None"
			);

			if (hasNone && diagnoses?.length === 0) {
				sentences?.push("The client reports no known mental or emotional health diagnoses.");
			} else if (diagnoses?.length > 0) {
				let diagnosisText;
				if (diagnoses?.length === 1) {
					diagnosisText = diagnoses[0];
				} else if (diagnoses.length === 2) {
					diagnosisText = diagnoses?.join(" and ");
				} else {
					diagnosisText = diagnoses?.slice(0, -1)?.join(", ") + ", and " + diagnoses?.slice(-1)[0];
				}
				sentences.push(`The client has been diagnosed with ${diagnosisText}.`);
			}

			// Add other mental health conditions if specified
			if (formValues?.emotional_2.includes('Other') && formValues?.otherhealth) {
				sentences?.push(`The client has also been diagnosed with ${formValues?.otherhealth}.`);
			}
			// If user doesn't select "SI" or "HI", show a denial sentence
			const hasSI = emotionalDiagnoses?.includes("SI (Suicidal Ideation)");
			const hasHI = emotionalDiagnoses?.includes("HI (Homicidal Ideation)");

			if (!hasSI && !hasHI) {
				sentences?.push("The client denies any history of suicidal or homicidal ideation.");
			} else {
				if (!hasSI && hasHI) {
					sentences?.push("The client denies any history of suicidal ideation.");
				}
				if (hasSI && !hasHI) {
					sentences?.push("The client denies any history of homicidal ideation.");
				}
			}
		}

		// Treatment history
		if (formValues?.emotional_10) {
			const treatmentStatus = formValues?.emotional_10 === 'received' ? 'has' : 'has never';
			sentences?.push(`The client ${treatmentStatus} received treatment for mental/emotional health conditions.`);

			// Add therapist details if treatment was received
			if (formValues?.emotional_10 === 'received' && formValues?.emotional_3) {
				sentences?.push(`The treating therapist/doctor was ${formValues?.emotional_3}.`);
			}
		}

		// Hospitalization history
		if (formValues?.emotional_11) {
			const hospitalizationStatus = formValues?.emotional_11 === 'was' ? 'has been' : 'has not been';
			sentences?.push(`The client ${hospitalizationStatus} hospitalized for mental/emotional health conditions.`);

			// Add hospital details if hospitalized (Note: form field name is empty, might need to fix)
			if (formValues?.emotional_11 === 'was' && formValues?.hospital_details) {
				sentences?.push(`Hospital details: ${formValues?.hospital_details}.`);
			}
		}

		// Medication status
		if (formValues?.emotional_12) {
			const medicationStatus = formValues?.emotional_12 === 'medication' ? 'is currently on' : 'is not on';
			sentences?.push(`The client ${medicationStatus} medication for mental/emotional health conditions.`);

			// Add medication details if on medication
			if (formValues?.emotional_12 === 'medication' && formValues?.emotional_5) {
				sentences?.push(`Current medications include: ${formValues?.emotional_5}.`);
			}
		}

		// Family history
		if (formValues?.family_mental_health) {
			switch (formValues?.family_mental_health) {
				case 'none':
					sentences?.push("The client reports no known family history of mental health or emotional health concerns.");
					break;
				case 'present':
					sentences?.push("The client reports a family history of mental health or emotional health concerns.");
					if (formValues?.family_mental_health_details) {
						sentences?.push(`Family history details: ${formValues?.family_mental_health_details}.`);
					}
					break;
				case 'unsure':
					sentences?.push("The client is unsure about family history of mental health concerns or prefers not to say.");
					break;
			}
		}

		return sentences;
	};

	const EXCLUDED_AGE_KEYS = ["not_applicable", "social_use", "religious_use", "social_gambling", "no_gambling"];
	const GAMBLING_KEYS = ["gambling", "social_gambling", "no_gambling"];
	let s_substance = screeningData?.selectedsubstances;
	let s_attempts = screeningData?.selectedattempts;
	let s_reasons = screeningData?.selectedreasons;

	const checkedSubstances = s_substance && typeof s_substance === "object"
		? Object.entries(s_substance).filter(([, value]) => value.checked)
		: [];

	const checkedKeys = checkedSubstances?.map(([key]) => key);

	// Flags
	const hasNotApplicable = checkedKeys?.includes("not_applicable");
	const hasNoGambling = checkedKeys?.includes("no_gambling");


	const generateDrugsPayload = () => {
		if (hasNotApplicable) {
			return `The client reports no substance use history. However, ${lowPronoun} reported problems in the past 12 months with`;
		}

		const drugSubstances = constants?.Substances.filter(
			sub => !GAMBLING_KEYS?.includes(sub.key) &&
				sub.key !== "not_applicable" &&
				checkedKeys?.includes(sub.key)
		);

		const rendered = drugSubstances?.map(substanceInfo => {
			const value = s_substance[substanceInfo.key];
			const displayAge = !EXCLUDED_AGE_KEYS.includes(substanceInfo.key)
				? ` at age ${value.age || "_____"}`
				: "";

			if (substanceInfo?.key === "other") {
				return `<h3><b>Other:</b> ${value?.textValue || "_____"}</h3>`;
			}

			let output = `<h3><b>${substanceInfo.substances}</b>${displayAge}</h3>`;

			// Nicotine handling
			if (substanceInfo?.key === "nicotine_vapes" && Array.isArray(substanceInfo?.nicotineOptions)) {
				const children = substanceInfo.nicotineOptions.map(opt => {
					const optData = value[opt.value];
					if (optData?.checked) {
						const optAge = optData.age || "_____";
						return `<li>${opt.label} at age ${optAge}</li>`;
					}
					return null;
				}).filter(Boolean);

				if (children.length) {
					output += `<ul>${children?.join("")}</ul>`;
				}
			}

			return output;
		});

		return rendered?.length ? (`${screeningData?.first_name} reported that ${lowPronoun} had begun to use ${rendered.join("")} gradually increasing amounts to achieve the desired effect over a longer period of time than intended, despite problems in the past 12 months with`) : "";
	};
	const drugsOutput = generateDrugsPayload();
	const reasonsPayload = constants.Reasons
		.filter((reason) => s_reasons && s_reasons[reason.key]?.checked)
		.map((reason) => {
			if (Array.isArray(constants.ReasonValues[reason.key])) {
				const checkedCauses = constants.ReasonValues[reason.key]
					.filter((cause) => s_reasons[reason.key]?.causes?.[cause]);
				return `<h3><b>${reason.reason}</b>: ${checkedCauses.length ? checkedCauses.join(", ") : "______"}</h3>`;
			} else {
				const cause = s_reasons[reason.key]?.cause || "______";
				return `<h3><b>${reason.reason}</b>: ${cause}</h3>`;
			}
		})
		.join("");

	const isNotApplicable = s_attempts?.B?.checked;

	const attemptsPayload = (constants.CageScreeningPre || [])
		.filter(item => s_attempts?.[item.key]?.checked && item.key !== "B")
		.map(item => item?.answer)
		.filter(Boolean)
		.join(", ");

	const generateDrugPart4Payload = () => {
		let output = '';

		if (!hasNotApplicable) {
			output += 'caused or exacerbated by use of substances, including reduced involvement in social activities.';
		}

		if (isNotApplicable) {
			output += ' CAGE screening is not applicable.';
		} else if (attemptsPayload) {
			output += ` The client reported several attempts to ${attemptsPayload}.`;
		}

		return output;
	};

	const drugPart4Payload = generateDrugPart4Payload();
	const ChemicalProblemParagraph = `
	Client was seen ${screeningData?.problem_1 ? screeningData?.problem_1 : "online/in-person"}, and during ${lowPossPronoun} assessment, outlined ${lowPossPronoun} substance abuse history. 
	${drugsOutput ?? ''} 
	${reasonsPayload ?? ''} 
	${drugPart4Payload ?? ''}
`;

	// gambling
	const generateGamblingPayload = () => {
		if (hasNoGambling) {
			return `<h3>The client denies any gambling history.</h3>`;
		}

		const gamblingSubstances = constants.Substances.filter(
			sub => GAMBLING_KEYS.includes(sub.key) &&
				sub.key !== "no_gambling" &&
				checkedKeys.includes(sub.key)
		);

		const rendered = gamblingSubstances.map(substanceInfo => {
			const value = s_substance[substanceInfo.key];
			const displayAge = !EXCLUDED_AGE_KEYS.includes(substanceInfo.key)
				? ` at age ${value.age || "_____"}`
				: "";

			let output = `<h3><b>${substanceInfo.substances}</b>${displayAge}</h3>`;

			if (substanceInfo.key === "gambling" && Array.isArray(substanceInfo.gamblingOptions)) {
				const children = Object.entries(value)
					.filter(([key, val]) => typeof val === "object" && val.checked)
					.map(([childKey, childVal]) => {
						const match = substanceInfo.gamblingOptions.find(opt => opt.value === childKey);
						if (match) {
							const sentence = childVal.checked ? match.yes : match.no;
							return `<li><h3>The client ${sentence}</h3></li>`;
						}
						return null;
					}).filter(Boolean);

				if (screeningData?.type_gambling || value?.textValue) {
					const typeGamblingArray = Array.isArray(screeningData?.type_gambling)
						? screeningData.type_gambling
						: (screeningData?.type_gambling ? [screeningData.type_gambling] : []);

					children.push(`<div><b>Type of gambling:</b> ${value.textValue ? "(" + value.textValue + ") " : ""}${typeGamblingArray.join(', ')}</div>`);
				}

				if (children.length) {
					output += `<ul>${children.join("")}</ul>`;
				}
			}

			return output;
		});

		return rendered.length ? rendered.join("") : "";
	};

	const gamblingOutput = generateGamblingPayload();
	//medical
	const generateMedicalSummary = (values) => {
		const sentences = [];

		// Health Status
		if (values?.medical_2) {
			sentences?.push(`The client's health status is reported as ${values?.medical_2}.`);
		}

		// Last Checkup
		if (values?.last_checkup_status === '1' && values?.medical_3?.date && values?.medical_3?.month && values?.medical_3?.year) {
			const { date, month, year } = values?.medical_3;
			const formattedDate = `${month.padStart(2, '0')}/${date.toString().padStart(2, '0')}/${year}`;
			sentences?.push(`The last checkup was on ${formattedDate}.`);
		} else if (values?.last_checkup_status === '2') {
			sentences?.push("The client does not remember their last checkup date.");
		}

		// Allergies
		if (values?.medical_4 === "Allergies") {
			sentences?.push(`The client has allergies: ${values?.medical_5 || "Details not provided"}.`);
		} else if (values?.medical_4 === "no Allergies") {
			sentences?.push("The client reports having no allergies.");
		}

		// Medications/OTCs
		if (values?.medical_8 === "medications/OTCs") {
			sentences.push(`The client is taking medications or OTCs: ${values?.medical_9 || "Details not provided"}.`);
		} else if (values?.medical_8 === "no medications/OTCs") {
			sentences.push("The client is not taking any medications or OTCs.");
		}

		// Dietary Habits
		const diet = constants.DietaryHabbits.find(d => d.key === values?.medical_10);
		if (diet) {
			sentences.push(`The client follows a ${diet.label.toLowerCase()} diet.`);
		}

		// Illnesses/Diseases
		if (values?.medical_6 === "illnesses/disease") {
			const illnesses = values?.selected_illnesses || [];

			// Replace "Other" with the value from "other_illness"
			const illnessList = illnesses.map((illness) =>
				illness === "Other" ? values?.other_illness : illness
			);

			const illnessSentence = `The client has the following illnesses or diseases: ${illnessList.join(', ')}.`;
			sentences.push(illnessSentence);
		} else if (values?.medical_6 === "no illnesses/disease") {
			sentences.push("The client reports having no illnesses or diseases.");
		}

		// Symptoms
		if (values?.mentalhealthoption?.length > 0) {
			const symptomsList = values?.mentalhealthoption.map(symptom => {
				if (symptom === "other_major_physical") {
					return values?.other_major_health_detail;
				}

				const option = constants.MentalHealthOptions.find(opt => opt.value === symptom);
				return option ? option.label : symptom;
			});

			const symptomSentence = `The client has experienced the following: ${symptomsList.join(', ')}.`;
			sentences.push(symptomSentence);
		} else {
			sentences.push("The client has not experienced any symptoms.");
		}

		return sentences.join(' ');
	};
	const generateGamblingSentences = (formValues) => {
		const sentences = []; if (formValues?.family_substance) {
			switch (formValues?.family_substance) {
				case 'none':
					sentences.push("The client reports no known family history of substance use or gambling use.");
					break;
				case 'present':
					sentences.push("The client reports a family history of substance use or gambling uses.");
					if (formValues?.family_substance_details) {
						sentences.push(`Family history details: ${formValues?.family_substance_details}.`);
					}
					break;
				case 'unsure':
					sentences.push("The client is unsure about family history of substance/gambling use or prefers not to say.");
					break;
			}
		}
		return sentences;

	};

	const handleBackClick = () => {
		if (history.length > 1) {
			history.goBack();
		} else {
			handleRedirect();
		}
	};

	const extraProblemData = {
		Chemical_Problem: <p dangerouslySetInnerHTML={{ __html: ChemicalProblemParagraph }} />,

		Gambling_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: `${gamblingOutput}${generateGamblingSentences(screeningData).join(' ')}`
				}}
			/>
		),

		Community_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: generateAddictionSentences(screeningData).join(' ')
				}}
			/>
		),

		Mental_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: generateMentalHealthSentences(screeningData).join(' ')
				}}
			/>
		),

		Physical_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: generateMedicalSummary(screeningData)
				}}
			/>
		),

		Social_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: `${pronoun} ${beVerb} ${screeningData?.family_13 || ""
						} and ${screeningData?.family_14 || ""} exercise, hobbies, recreational interests, sports, leisure activities ${screeningData?.family_14 === "does no" ? "" : "like " + (screeningData?.family_15 || "")
						} in ${lowPossPronoun} free time.`
				}}
			/>
		),

		Family_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: `Client is the ${screeningData?.family_1 === "only"
						? screeningData?.family_1 + " child"
						: (screeningData?.family_1 || "") +
						" of " +
						(screeningData?.family_2 || "") +
						" children"
						} and is ${screeningData?.family_3 || ""}. ${pronoun} report${past} that ${lowPronoun} ${beVerb} ${screeningData?.maritalstatus
							? constants?.MaritalStatusOption[maritalstatuslabelindex]?.label
							: "----"
						}. ${pronoun} report${past} ${screeningData?.family_4} relations with family of origin (parents) (Father: ${screeningData?.father_name || ""
						}, Mother: ${screeningData?.mother_name || ""
						}) and ${screeningData?.family_5} relations with nuclear family (Spouse/partner) (${screeningData?.spouse_name
						}), ${screeningData?.family_6 === "has no"
							? ""
							: "and has children (" + screeningData?.children_name + " " + screeningData?.family_7 + ")"
						}. ${screeningData?.family_1 === "only"
							? ""
							: `Client reports ${screeningData?.family_16 || ""} sibling relations ${screeningData?.sibling_display ? `(${screeningData?.sibling_display})` : ""
							}.`
						}`
				}}
			/>
		),

		Spiritual_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: `The client identifies their religion as ${screeningData?.intro_3 || ""
						}. ${screeningData?.spiritual_1
							? `Regarding their spiritual and religious beliefs, the client states: "${screeningData?.spiritual_1}". `
							: ""
						}The client believes their spiritual beliefs and values will support their recovery in the following way: "${screeningData?.spiritual_2 || ""
						}"`
				}}
			/>
		),

		Education_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: `${screeningData?.first_name} has completed ${constants?.EducationOptions[educationlabelindex]?.label || "-------"
						}${screeningData?.family_10 === "14" || screeningData?.family_10 === "15"
							? ` - ${screeningData?.education_details || ""}`
							: ""
						}.`
				}}
			/>
		),

		Employment_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: `Client is ${constants?.OccupationOptions[occupationlabelindex]?.label || "-------"
						}${screeningData?.family_11 === "works as a" ? screeningData?.family_12 || "" : ""
						}.`
				}}
			/>
		),

		Legal_Problem: (
			<p
				dangerouslySetInnerHTML={{
					__html: `${screeningData?.first_name} reports ${screeningData?.family_8} legal issues${screeningData?.family_8 === "current" ? " (" + screeningData?.family_9 + ")" : ""
						}.`
				}}
			/>
		)
	};

	const problemQuestions = constants.ComprehensivePsychosocialOptions.map(section => ({
		...section,
		questions: section.questions.filter(q => q.name.includes('_Problem'))
	})).filter(section => section.questions.length > 0);

	const handleRedirect = () => {
		if (isAdmin) {
			if (adminEnquiryValuefromSession?.enquiry_id) {
				history.push("/view-enquiry");
			} else {
				history.push("/view-client");
			}
		} else {
			history.push("/dashboard");
		}
	};

	const DiagnosisSelect = ({ label, name, options }) => (
		<Col xs={24} lg={12} xl={8}>
			<Form.Item label={label} name={name}>
				<Select
					mode='tags'
					placeholder={`Select ${label}`}
					disabled={isSigned && !enableEdit}
					allowClear
					showSearch
					optionFilterProp="children"
					optionLabelProp="label"
					dropdownStyle={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}
					tagRender={tagRender}
					filterOption={(input, option) =>
						(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
					}
				>
					{options?.map(option => (
						<Select.Option key={option.value} value={option.value} label={option.label}>
							<span className="whitespace-normal">{option.label}</span>
						</Select.Option>
					))}
				</Select>
			</Form.Item>
		</Col>
	);

	const sortByLabelSafe = (options) =>
		Array.isArray(options)
			? [...options].sort((a, b) => (a.label || '').localeCompare(b.label || ''))
			: [];

	const diagnosisFields = [
		{
			label: 'Primary Addiction Diagnosis',
			name: 'primary_diagnosis',
			options: sortByLabelSafe(constants.primarySecondaryTertiaryOptions)
		},
		{
			label: 'Secondary Addiction Diagnosis',
			name: 'secondary_diagnosis',
			options: sortByLabelSafe(constants.primarySecondaryTertiaryOptions)
		},
		{
			label: 'Tertiary Addiction Diagnosis',
			name: 'tertiary_diagnosis',
			options: sortByLabelSafe(constants.primarySecondaryTertiaryOptions)
		},
		{
			label: 'Primary Mental Diagnosis',
			name: 'other_cd_diagnosis',
			options: sortByLabelSafe(constants.mentalHealthDiagOptions)
		},
		{
			label: 'Secondary Mental Diagnosis',
			name: 'mental_health_diagnosis_2',
			options: sortByLabelSafe(constants.mentalHealthDiagOptions)
		},
		{
			label: 'Tertiary Mental Diagnosis',
			name: 'mental_health_diagnosis_3',
			options: sortByLabelSafe(constants.mentalHealthDiagOptions)
		},
		{
			label: 'Primary Other Diagnosis',
			name: 'other_diagnosis_1',
			options: sortByLabelSafe(constants.Otheroptions)
		},
		{
			label: 'Secondary Other Diagnosis',
			name: 'other_diagnosis_2',
			options: sortByLabelSafe(constants.Otheroptions)
		},
		{
			label: 'Tertiary Other Diagnosis',
			name: 'other_diagnosis_3',
			options: sortByLabelSafe(constants.Otheroptions)
		},
	];

	const getListAssociates = () => {
		fetchAdminApi(`/view-associates`, "post").then((res) => {
			if (res?.data) {
				const firstItem = res?.data?.filter(obj => obj?.client_id === "1")[0];
				const remainingItems = res?.data?.filter(obj => obj?.client_id !== "1");
				let sortedData;
				if (firstItem) {
					sortedData = [firstItem, ...remainingItems];
				} else {
					sortedData = remainingItems
				}
				setListAssociates(sortedData);
				// Check if any associate matches the logged-in admin_id AND is in the allowed list
				const matchedUser = res.data.find(
					(user) => Number(user.client_id) === Number(admin_id) && constants.AllowedClientIds.includes(Number(user.client_id))
				);
				if (matchedUser) {
					setEnableEdit(true);
					setUpdatedByName(`${matchedUser.firstname} ${matchedUser.lastname}`);
				} else {
					setEnableEdit(false);
				}
			}
			else {
				setListAssociates([]);
			}
		});
	}
	const selectFilterOption = (input, option) => {
		return option.props.children.toLowerCase().indexOf(input.toLowerCase()) > -1 && option.props.children.toLowerCase().indexOf(input.toLowerCase()) < 1;
	};

	useEffect(() => {
		// if (assess6Value === 'agreed') { getListAssociates(); }
		getListAssociates()
	}, []);

	const handleSign = () => {
		const selectedAssignee = form.getFieldValue("assignto");

		let payload = JSON.parse(sessionStorage.getItem("enquiryDetails"));

		if (!payload) {
			const clientDetailsForReset = JSON.parse(sessionStorage.getItem("clientDetailsForReset"));

			if (clientDetailsForReset) {
				// Full client record available (reset flow) — build enquiryDetails-shaped payload
				payload = { ...clientDetailsForReset, enquiry_id: clientDetailsForReset?.enquiry_info?.enquiry_id };
			} else {
				// Fallback: no full record, only the sparse admin value
				const adminClientValue = JSON.parse(sessionStorage.getItem("adminClientValue")) || {};
				payload = {
					client_id: adminClientValue?.clientId,
					client_serial_number: adminClientValue?.client_serial_number,
					client_name: adminClientValue?.client_name,
				};
			}
		}

		payload.userType = "coachingAgreement";
		payload.isScreening = true;
		payload.assigned_to = selectedAssignee || "";
		sessionStorage.setItem("enquiryDetails", JSON.stringify(payload));
		window.open(constants.BaseUrl + "/registration-plans");
	};

	const tagRender = (props) => {
		const { label, closable, onClose } = props;

		return (
			<Tag
				closable={!isSigned && closable}
				onClose={onClose}
				className={`!h-auto !inline-flex !items-center !break-words !whitespace-normal !text-sm ${isSigned ? 'ant-select-disabled' : ''}`}
			>
				{label}
			</Tag>
		);
	};

	const InputSwitcher = ({ question, extraProblemData, isSigned }) => {
		const paraFieldName = `${question.name}_para`;
		const selectedInputType = Form.useWatch(paraFieldName);

		return (
			<>
				<Form.Item
					label={`Choose note method`}
					name={paraFieldName}
				>
					<Radio.Group disabled={isSigned}>
						<Radio value="manual">Add Note</Radio>
						<Radio value="auto">Auto-Generated Note</Radio>
					</Radio.Group>
				</Form.Item>

				{selectedInputType === 'manual' && (
					<Form.Item
						name={`${question.name}_manual`}
					>
						<Input.TextArea
							rows={4}
							placeholder="Add notes or comments here..."
							disabled={isSigned}
						/>
					</Form.Item>
				)}

				{selectedInputType === 'auto' && (
					<Form.Item
						name={`${question.name}_auto`}
					>
						<Tag className="text-sm whitespace-normal w-full p-4">
							{extraProblemData[question.name]}
						</Tag>
					</Form.Item>
				)}
			</>
		);
	};

	return (
		<Spin spinning={loader} size="large">
			<div className='text-center bg-amber-300 text-lg font-semibold p-3'>{constants.Subtitle}
				<span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl">{constants.ScreeningForm}</span>
			</div>
			{getScreeningHeader()}

			<div className='container mx-auto'>
				<div className="px-2 pb-2">
					<div className='flex gap-5 flex-wrap justify-between'>
						{DOB(noteDate.month, handleNoteMonthChange, noteDate.date, handleNoteDayChange, noteDate.year, handleNoteYearChange, "Date", isSigned)}
					</div>
					<Card>
						<Form
							form={form}
							layout="vertical"
							className="client-details mb-10 disabled-dark"
							initialValues={formValues}
						>
							<div className='-mx-2'>{panelTitle("Results for Screening:")}</div>
							{renderScreeningResults()}
							<Row gutter={[12, 12]}>
								{panelTitle("Comprehensive Psychosocial Assessment:")}

								<div className="w-full">
									{problemQuestions.map((section, i) => (
										<div key={section.topic}>
											<h2 className='text-base font-bold underline my-2 px-2'>{section.topic}</h2>

											{section.questions.map((question, index) => {
												const isLastSection = i === problemQuestions.length - 1;
												const isLastQuestion = index === section.questions.length - 1;
												const isLastOfAll = isLastSection && isLastQuestion;

												return (
													<div key={question.name}>

														<Col xs={24}>
															<InputSwitcher
																question={question}
																extraProblemData={extraProblemData}
																isSigned={isSigned}
															/></Col>

														<Col xs={24}>
															<Form.Item label={question.label} name={question.name}>
																<Select
																	placeholder={question.placeholder}
																	mode='tags'
																	disabled={isSigned && !enableEdit}
																	tagRender={tagRender}
																	dropdownStyle={{ whiteSpace: "normal" }}
																>
																	{question.options.map((option) => (
																		<Option key={option.key} value={option.label}>
																			<div className='whitespace-normal'>
																				{option.label}
																			</div>
																		</Option>
																	))}
																</Select>
															</Form.Item>
														</Col>

														{!isLastOfAll && (
															<Col xs={24}>
																<Divider />
															</Col>
														)}
													</div>
												)
											})}
										</div>
									))}
								</div>

								<Divider className='border border-gray-600' />
								<Row gutter={[12, 12]} className={enableEdit ? '' : "pointer-events-none opacity-80"}>
									{panelTitle(`${constants.LocatrAssessment}:`)}
									<Col xs={24} lg={24}>
										{<LocadtrAssessment assessmentQuestions={assessmentQuestions} />}
									</Col>
									<Col xs={24}>
										<Form.Item
											name="gaf_scale" label="Global Assessment of Functioning (GAF) Scale"
											rules={[{ required: enableEdit, message: "Please select a GAF score!" }]}
										>
											<Select
												placeholder="Select GAF Score"
												dropdownStyle={{ whiteSpace: "normal" }}
												showSearch
												optionLabelProp="label"
												filterOption={(input, option) =>
													(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
												}
												disabled={isSigned && !enableEdit}
											>
												{constants.GAFScaleOptions.map(({ value, score, description }) => (
													<Select.Option key={value} value={value} label={`${score}: ${description}`}>
														<div className='whitespace-normal'>
															<strong>{score}:</strong> {description}
														</div>
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>

									{panelTitle("Initial Diagnosis:")}
									<Col xs={24}>
										<p className='font-bold text-sm'>Please indicate specific diagnosis of alcohol related or psychoactive substance related disorder in accordance with the current version of the DSM.</p>
									</Col>

									{diagnosisFields.map(field => (
										<DiagnosisSelect
											key={field.name}
											label={field.label}
											name={field.name}
											options={field.options}
										/>
									))}

									<Col xs={24}>
										<Form.Item name="screening_assessment" label="Summary of Feedback given to the Recipient Based on the Results of the Screening">
											<Radio.Group disabled={isSigned && !enableEdit}>
												{getScreeningRadioOptions().map((option, index) => (
													<Radio
														key={index}
														value={option.value}
														className='mt-2'
													>
														{option.label}
													</Radio>
												))}
											</Radio.Group>
										</Form.Item>
									</Col>

									<Col xs={24} lg={24}>
										<Form.Item label="Recommendation" name="recommendation" allowClear>
											<Checkbox.Group className='w-full' disabled={isSigned && !enableEdit}>
												<Row>
													{
														constants.RecommendationOptions.map((val) => {
															return <Col xs={24} md={12} lg={8} xl={6} key={val.value}>
																<Checkbox value={val?.value}>{val?.label}</Checkbox>
															</Col>
														})
													}
												</Row>
											</Checkbox.Group>
										</Form.Item>
									</Col>

									<Col xs={24}>
										<div className="flex flex-wrap gap-2 text-[14px] items-center">
											<span>Client</span>
											<Form.Item name="assess_6" className='!mb-0'>
												<Select placeholder="agreed/disagreed" allowClear disabled={isSigned && !enableEdit}>
													<Option value="agreed">agreed</Option>
													<Option value="declined">declined</Option>
												</Select>
											</Form.Item>
											<span>to enter the program</span>
											{assess6Value === 'agreed' && (
												<>
													<span>and will be sent the coaching agreement and payment forms</span>
													<span>, and is assigned to</span>
													<Form.Item name="assignto" className='!mb-0'>
														<Select
															placeholder={constants.AssignedTo}
															showSearch
															allowClear
															filterOption={selectFilterOption}
															className='min-w-[200px]'
															disabled={isSigned && !enableEdit}
														>
															{
																listAssociates?.map((associate) => <Option value={associate?.client_id} key={associate?.client_id}>{associate?.firstname + ' ' + associate?.lastname}</Option>)
															}
														</Select>
													</Form.Item>
												</>
											)}
											<span>.</span>
										</div>
									</Col>
								</Row>
							</Row>

							<Divider />
							<Space wrap>
								<Button className="bg-sky-800 text-white uppercase" onClick={handleRedirect}>{constants.Cancel}</Button>
								{
									isAdmin && (
										<>
											<Button className="bg-sky-800 text-white uppercase" onClick={handleSubmit} disabled={isSigned && !enableEdit}>{constants.Save}</Button>
											{!adminClientValuefromSession?.clientId || noteData?.reset_date ? (<Button className="bg-sky-800 text-white uppercase" onClick={handleSign} disabled={status === "4" && status === "11"}>{constants.CoachingAgreement}</Button>) : null}
											<Popconfirm title={enableEdit ? "Are you sure you want to Esign the note?" : "You will not be able to Edit after you Esign the Notes"} onConfirm={() => handleSubmit("esign")}>
												<Button className="bg-sky-800 text-white uppercase" disabled={isSigned}>{constants.Esign}</Button>
											</Popconfirm>
											<Button className="bg-sky-800 text-white uppercase" onClick={handleDownloadPDF}>{constants.DownloadPDF}</Button>
										</>
									)}
							</Space>

							{isAdmin && isSigned && (
								<div className="mt-3 flex flex-col gap-1 text-sm italic text-gray-600">
									{noteData?.screening_data?.signed_by_name && (
										<span>
											E-signed by {noteData.screening_data.signed_by_name} on{" "}
											{moment(noteData.screening_data.signed_on).format(constants.dateformat)}
										</span>
									)}

									{noteData?.screening_data?.screening?.updated_by && (
										<span>
											Updated by {noteData.screening_data.screening.updated_by} on{" "}
											{moment(noteData.screening_data.screening.updated_on).format(constants.dateformat)}
										</span>
									)}
								</div>
							)}

						</Form>
					</Card>
				</div>
			</div>
		</Spin>
	);
};
export default ScreeningForm;